import React, { createContext, useContext, useState, ReactNode } from 'react';
import { ISuggestionForm } from '../types/suggestions/form';
import { ISuggestion } from './SuggestionsContext';

interface FormContextType {
  activeForm: ISuggestionForm | null;
  isFormOpen: boolean;
  suggestion: ISuggestion | null;
  openForm: (form: ISuggestionForm, suggestion: ISuggestion | null) => void;
  closeForm: () => void;
}

const FormContext = createContext<FormContextType | undefined>(undefined);

export const FormProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [activeForm, setActiveForm] = useState<ISuggestionForm | null>(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [suggestion, setSuggestion] = useState<ISuggestion | null>(null);

  const openForm = (form: ISuggestionForm, suggestion: ISuggestion | null) => {
    console.log('FormContext: Opening form', form);
    setActiveForm(form);
    setSuggestion(suggestion);
    setIsFormOpen(true);
  };

  const closeForm = () => {
    console.log('FormContext: Closing form');
    setIsFormOpen(false);
    setActiveForm(null);
    setSuggestion(null);
  };

  return (
    <FormContext.Provider value={{ activeForm, isFormOpen, suggestion, openForm, closeForm }}>
      {children}
    </FormContext.Provider>
  );
};

export const useForm = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error('useForm must be used within a FormProvider');
  }
  return context;
};
